export const googleCloudConfig = {
	"mapsApiKey": "AIzaSyB8DguVMrEGo8p8hxJW5VgravD1nlAHMdE"
};